<template>
  <c-panel caption="アカウント">
    <template>
      <c-panel-content caption="Email">
        <span>{{user.account.email}}</span>
      </c-panel-content>

      <c-panel-content caption="パスワード">
        <span>********</span>
      </c-panel-content>
    </template>

    <template #actions>
      <c-panel-action
        caption="メールアドレスを変更する"
        :to="{ name: 'my/email' }"
      />
      <c-panel-action
        caption="ログインパスワードを変更する"
        :to="{ name: 'my/password' }"
      />
    </template>
  </c-panel>
</template>

<script>
import base from './base'

export default {
  name: 'CAccountPanel',
  mixins: [
    base
  ]
}
</script>
